import { render, staticRenderFns } from "./ReplyChatContent.vue?vue&type=template&id=2a01913e"
import script from "./ReplyChatContent.vue?vue&type=script&lang=js"
export * from "./ReplyChatContent.vue?vue&type=script&lang=js"
import style0 from "./ReplyChatContent.vue?vue&type=style&index=0&id=2a01913e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports